import { Controller } from "@hotwired/stimulus"

// Lightweight in-page tabs. Tab buttons and panels share a data-tab-name value.
// Uses the WAI-ARIA tablist keyboard pattern: Left/Right, Home/End.
export default class extends Controller {
  static targets = ["tab", "panel"]
  static values = {
    active: { type: String, default: "" },
  }

  connect() {
    if (!this.activeValue && this.hasTabTarget) {
      this.activeValue = this.tabTargets[0].dataset.tabName
    }
    this.showActive()
  }

  select(event) {
    this.activate(event.currentTarget)
  }

  navigate(event) {
    const keys = ["ArrowLeft", "ArrowRight", "Home", "End"]
    if (!keys.includes(event.key)) return

    event.preventDefault()

    const currentIndex = this.tabTargets.indexOf(event.currentTarget)
    if (currentIndex < 0) return

    let nextIndex = currentIndex
    switch (event.key) {
      case "ArrowLeft":
        nextIndex = (currentIndex - 1 + this.tabTargets.length) % this.tabTargets.length
        break
      case "ArrowRight":
        nextIndex = (currentIndex + 1) % this.tabTargets.length
        break
      case "Home":
        nextIndex = 0
        break
      case "End":
        nextIndex = this.tabTargets.length - 1
        break
    }

    this.activate(this.tabTargets[nextIndex], { focus: true })
  }

  activate(tab, { focus = false } = {}) {
    const name = tab?.dataset?.tabName
    if (!name) return

    if (name !== this.activeValue) {
      this.activeValue = name
      this.showActive()
    }

    if (focus) tab.focus()
  }

  showActive() {
    this.tabTargets.forEach((tab) => {
      const selected = tab.dataset.tabName === this.activeValue
      tab.classList.toggle("selected", selected)
      tab.setAttribute("aria-selected", selected ? "true" : "false")
      tab.tabIndex = selected ? 0 : -1
    })

    this.panelTargets.forEach((panel) => {
      panel.hidden = panel.dataset.tabName !== this.activeValue
    })
  }
}
